import dayjs from "dayjs";
import React from "react";

import style from "./CashbackProgramResume.module.scss";
import { If } from "shared/components/control-statements";
import { Currency } from "shared/utils/Currency";
import { PointValue } from "shared/core/program/PointValue";
import { CashbackValue } from "shared/core/program/CashbackValue";

export class CashbackProgramResume extends React.Component {
  formatPercent() {
    return `${+(this.props.cashback?.percentage || 0)}%`;
  }

  formatHour(time) {
    return dayjs(time).format("HH:mm");
  }

  formatMessage(message) {
    return message?.text
      ? message?.text.replace("<link>", message?.link)
      : "Sem mensagem configurada";
  }

  formatMessageExpiration(message) {
    return message?.text
      ? message?.text.replace("<link>", message?.link)
      : "Sem mensagem configurada";
  }

  formatCurrency(value) {
    const formated = parseFloat(value);

    return formated.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
  }

  formatValue(value) {
    const { cashback, programLabels } = this.props;
    const programType = cashback?.type || "CASHBACK";
    
    if (programType === "POINT") {
      return PointValue.format(value, programLabels);
    }

    return CashbackValue.format(value, programLabels);
  }

  render() {
    const { cashback } = this.props;

    if (!cashback) return null;
    

    return (
      <div className={style["resume-cashback"]}>
        <div className="d-flex align-center justify-between w-100 mb-20">
          <If cond={cashback.type !== "POINT"}>
            <div className={style.cashback}>
              <p>Cashback de&nbsp;</p>
              <span className={style.value}>{this.formatPercent()}</span>
            </div>
          </If>

          <If cond={cashback.type === "POINT"}>
            <div className={style.cashback}>
              <p>
                Câmbio de&nbsp;
                <span className={style.value}>
                  {this.formatValue(cashback.percentage)}
                </span>
                &nbsp;para {Currency.formatCurrency(100)}
              </p>
            </div>
          </If>

          <div className={style.details}>
            <div className={style.item}>
              <p>Expira em:</p>&nbsp;
              <span>{cashback.expiration_days} dia(s)</span>
            </div>
            <div className={style.hairline} />
            <div className={style.item}>
              <p>Limite de ganho:</p>&nbsp;
              <span>
                {this.formatValue(cashback.max_gain)}
              </span>
            </div>
          </div>
        </div>
        <div className={style.messages}>
          <div className={style.box}>
            <p className={style.title}>Comunicação de recebimento</p>
            <p className={style.message}>
              {this.formatMessage(cashback.message)}
            </p>
          </div>
          <div className={style.box}>
            <div className="d-flex align-center justify-between">
              <p className={style.title}>Lembrete de expiração</p>
              <div className={style.expiration}>
                <p>
                  {cashback.expiration_message
                    ? cashback.expiration_message.remind_days_before
                    : "-"}{" "}
                  dia(s) antes da expiração
                </p>
                <div className={style.hairline} />
                <p>Enviado às</p>
                <span>
                  &nbsp;&nbsp;-&nbsp;&nbsp;
                  {cashback.expiration_message
                    ? cashback.expiration_message.remind_hour
                    : "-"}
                </span>
              </div>
            </div>
            <p className={style.message}>
              {this.formatMessageExpiration(cashback.expiration_message)}
            </p>
          </div>
        </div>
      </div>
    );
  }
}
